/**
 * The external dependencies.
 */
import React from "react";

/**
 * The internal dependencies.
 */
import ModalFrame from "./ModalFrame";
import FormConfirmation from "components/form/FormConfirmation";

/**
 * @class      ModalConfirmation (name)
 * @param      {Object} / The properties
 * @return     {JSX}
 */
const ModalConfirmation = (props) => {
  return (
    <ModalFrame>
      <FormConfirmation />
    </ModalFrame>
  );
};

export default ModalConfirmation;
